import type { ZodBoolean } from "zod"

import { z } from "zod"

export const zBooleanOnly = z
  .string()
  .or(z.boolean())
  .refine(s => s === "true" || s === "false" || s === true || s === false)
  .transform(s => s === "true" || s === true)

/**
 * Creates a ZodBoolean that is false when undefined
 */
export const zDefaultBoolean = z
  .boolean()
  .optional()
  .transform(rawValue => rawValue ?? false)

/**
 * Creates a ZodBoolean based on a ZodBoolean that is false when undefined
 * @param boolean
 */
export function createDefaultBoolean(boolean: ZodBoolean) {
  return boolean.optional().transform(rawValue => rawValue ?? false)
}

/**
 * Creates a zod Date that is transformed to an ISO String automatically
 */
export const zDateTransform = z.date().transform(data => data.toISOString())
